import * as UserActions from '@services/user/user.actions';
import * as React from 'react';
import {connect} from 'react-redux';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import ForgotPassword from "@components/forgot-password/forgot-password.component";
import FullScreenCard from "@components/common/fullscreencard/FullScreenCard";
import VarannanVeckaLogo from "@components/svg/varannanvecka";

interface IProps extends RouteComponentProps {
    forgotPassword: (values: any) => void;
}

class PForgotPasswordContainer extends React.Component<IProps> {

    public render() {
        return (
            <FullScreenCard sideElement={<VarannanVeckaLogo/>}>
                <ForgotPassword onSubmit={this.handleSubmit} />
            </FullScreenCard>
        );
    }

    private handleSubmit = (values: any) => {
        this.props.forgotPassword({
            data: values,
            meta: {
                history: this.props.history
            }
        });
    }
}

const mapDispatchToProps = {
    forgotPassword: UserActions.forgotPassword,
};

// tslint:disable-next-line:max-line-length
const ForgotPasswordContainer = withRouter(connect(null, mapDispatchToProps)(PForgotPasswordContainer));

export default ForgotPasswordContainer;



// WEBPACK FOOTER //
// ./src/containers/forgot-password/forgot-password.container.tsx